<span class="more-indicator">
    <svg *ngIf="down" class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#pijl-down-bold"></use></svg>
    <svg *ngIf="up" class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#pijl-up-bold"></use></svg>
</span>
